import { message } from "antd";
import InternalApi from "../axios/internalApi";

export const getAllBanners = async () => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `admin/banner`
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const listDealBanners = async () => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `banner/deal-banner`
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const createBanner = async (payload) => {
  try {
    return await InternalApi.post(
      {
        server: "api/v1/",
        path: `admin/banner`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const createDealBanner = async (payload) => {
  try {
    return await InternalApi.post(
      {
        server: "api/v1/",
        path: `admin/deal-banner`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateBanner = async (id, payload) => {
  try {
    return await InternalApi.patch(
      {
        server: "api/v1/",
        path: `admin/banner/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateDealBanner = async (id, payload) => {
  try {
    return await InternalApi.patch(
      {
        server: "api/v1/",
        path: `admin/deal-banner/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const deleteDealBanner = async (id) => {
  try {
    return await InternalApi.delete(
      {
        server: "api/v1/",
        path: `admin/delete-deal-banner/${id}`,
      }
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};


export const updateStatus = async (id, payload) => {
  try {
    return await InternalApi.patch(
      {
        server: "api/v1/",
        path: `admin/banner/${id}/status`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getCarouselBanners = async () => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `admin/banner/simple`
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const createCarouselBanner = async (payload) => {
  try {
    return await InternalApi.post(
      {
        server: "api/v1/",
        path: `banner/simple-banner`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateSimpleBanner = async (id, payload) => {
  try {
    return await InternalApi.patch(
      {
        server: "api/v1/",
        path: `banner/simple-banner/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};